export default __webpack_public_path__ + "static/media/light.b96c98d9.woff";